var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('card-notes',{staticClass:"offer-card-notes",attrs:{"is-add-file":true,"items":_vm.offer.notes,"headers":_vm.headers,"time-data":_vm.timeData,"key-image":"image","key-text":"text"},on:{"add":_vm.addNote,"delete":_vm.deleteNote,"save":_vm.saveNote}})
}
var staticRenderFns = []

export { render, staticRenderFns }